import { Playground } from 'docz';
import { Button, Inline, Row, Column } from 'react-nails';
import CustomButton from "..\\..\\..\\..\\..\\docz\\Controls\\CustomButton";
import React from 'react';
export default {
  Playground,
  Button,
  Inline,
  Row,
  Column,
  CustomButton,
  React
};